import { Injectable } from '@angular/core';

@Injectable()
export class HelperService {

  constructor() { }

  isset (item) {
    return !(item === undefined || item === -1);
  }

  oneDecString (value){
    return (Math.round( value * 10 ) / 10).toString()
  }

  isEmpty (obj){
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }

  redirectToComponent (message, router, params){
    let url = '';
    if(message.app === "crichq"){
      url = "cricket";
    }else if(message.app === "qsleaderboard"){
      url = "qsleaderbaord";
    }else if(message.app === "qsrugby"){
      url = "qsrugby";
    }
    router.navigate([`/${url}/${+params['id']}/live`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/helper.service.ts